<template>
    <div>
        <rkm-area
            v-if="model"
            title="Paciente"
            type="fieldset"
            no-margin-top
        >
            <rkm-row>
                <rkm-col cols="12">
                    <h4>{{ model.nome }} <strong v-if="paciente.preferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL"> ({{ paciente.nomeSocial }})</strong></h4>
                </rkm-col>

                <rkm-col cols="4">
                    <p>
                        <strong>Prontuário:</strong>
                        {{ model.prontuario }}
                    </p>
                    <p>
                        <strong>Telefone(s):</strong>
                        <template v-if="model.telefones">
                            {{ model.telefones }}
                        </template>
                        <template v-else>
                            <i>Não informado</i>
                        </template>
                    </p>
                    <p>
                        <strong>Sexo:</strong>
                        {{ model.sexo }}
                    </p>
                </rkm-col>

                <rkm-col cols="4">
                    <p>
                        <strong>CPF:</strong>
                        {{ model.cpf }}
                    </p>
                    <p>
                        <strong>Data de nascimento:</strong>
                        {{ model.dataNascimento}}
                    </p>
                    <p>
                        <strong>Nome da mãe:</strong>
                        {{ model.nomeMae }}
                    </p>
                </rkm-col>
                <rkm-col cols="4">
                    <p>
                        <strong>CNS:</strong>
                        {{ model.cns }}
                    </p>
                    <p>
                        <strong>Idade:</strong>
                        {{ model.idade }}
                    </p>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-form
            ref="Form"
        >
            <rkm-area
                title="PROFISSIONAL"
                type="fieldset"
                class="mt-4"
            >
                <rkm-row>
                    <rkm-col cols="12">
                        <h5>{{ form.usuario }}</h5>
                    </rkm-col>
                    <rkm-col cols="4">
                        <p>
                            <strong>CBO:</strong>
                            {{ form.ocupacaoNome }}
                        </p>
                    </rkm-col>

                    <rkm-col cols="4">
                        <p>
                            <strong>Data da anotação:</strong>
                            {{ form.dataAtual }}
                        </p>
                    </rkm-col>
                </rkm-row>
            </rkm-area>


            <rkm-area
                title="NOVA ANOTAÇÃO"
                type="fieldset"
                class="mt-4"
                v-if="model"
            >
                <rkm-row>
                    <rkm-col cols="12">
                       <rkm-text-editor
                            label="Anotação"
                            name="anotacao"
                            v-model="model.anotacao"
                            :validations="validations.anotacao"
                        />

                        <rkm-form-group class="p-0">
                            <template
                                v-if="model.historico.length > 0"
                                slot="label"
                            >
                                <rkm-row>
                                    <rkm-col class="text-right" cols="12">
                                        <rkm-button
                                            v-if="model.historico.length > 0"
                                            @click.stop="visible = !visible"
                                        >
                                            {{ `${model.historico.length} registro(s)` }}
                                        </rkm-button>
                                    </rkm-col>
                                </rkm-row>
                            </template>

                            <template v-if="readonly">
                                <rkm-list
                                    :items="model.historico"
                                    hide-filters
                                    hide-pagination
                                >
                                    <template v-slot="{ item }">
                                        <div> Profissional: {{  item.profissional.nome}} -  CBO: {{  item.profissional.cbo}}</div>
                                        <div>Data: {{ item.data }} às {{ item.horario }}</div>
                                        <div class="html" v-html="item.anotacao"></div>
                                    </template>
                                </rkm-list>
                            </template>

                            <template v-else>
                                <rkm-collapse
                                    v-if="model.historico.length > 0"
                                    :visible="visible"
                                    class="mb-1"
                                >
                                    <rkm-list-group>
                                        <rkm-list-group-item
                                            v-for="(item, i) in model.historico"
                                            v-bind:key="i"
                                        >
                                            <rkm-row cols="12">
                                                <rkm-col cols="9">
                                                    Profissional: {{  item.profissional.nome}} -  CBO: {{  item.profissional.cbo}}
                                                </rkm-col>
                                                <rkm-col cols="3 text-right">Data: {{ item.data }} ás {{ item.horario }}</rkm-col>
                                            </rkm-row>

                                            <rkm-row cols="12 ml-0">
                                                Anotação: <div style="margin-left:5px" class="html" v-html="item.anotacao"></div>
                                            </rkm-row>
                                        </rkm-list-group-item>
                                    </rkm-list-group>
                                </rkm-collapse>
                            </template>
                        </rkm-form-group>
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </rkm-form>
    </div>
</template>

<script>

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, error, object, data, stringCase } from '@/mixins'

// Filters.
import format from '@/filters/formats'

//Moments
import moment from 'moment'

// Enums.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

export default {
        computed: {
        validations() {

            return {
                anotacao: {
                    max: 1500,
                    min: 3,
                },
            }
        }
    },
    created() {

        this.repositories = {
            assistenciaSocial: this.getConectaSusRepository('prontoAtendimento.assistenciaSocial'),
            impressao: this.getConectaSusRepository('prontoAtendimento.impressaoFaaEletronica'),
            faaImpressao: this.getConectaSusRepository('impressao.prontoAtendimento')
        }

        this.load()
    },
    data: () => ({
        local: {
            laudo: null
        },
        model: null,
        form: {
            paciente: {
                cidadao:[]
            },
        },
        items: [],
        visible: false,
        paciente: {
            nome: null,
            sexo: {
                descricao: null
            },
            idade: []
        },
        enums: { preferenciaNome }
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.assistenciaSocial.edit(this.id)
                .then(({ data }) => {

                    this.model = this.clone(data.model.anotacoes)
                    this.form = this.clone(data.form)
                    this.model.telefones = this.handlePhone(data.model.anotacoes.telefones)

                    this.paciente.nome = data.model.anotacoes.nome
                    this.paciente.nomeSocial = data.model.anotacoes.nomeSocial
                    this.paciente.sexo.descricao = data.model.anotacoes.sexo
                    this.paciente.idade = data.model.anotacoes.idadePaciente
                    this.paciente.preferenciaNomeId = data.model.anotacoes.preferenciaNomeId

                    this.$emit('paciente', this.paciente)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handlePhone(obj) {

            let telefones = ''

            Object.keys(obj).forEach(function(value, i) {

                if (i === 0) {
                    telefones = telefones.concat(obj[value])
                } else {
                    telefones = telefones.concat(`, ${obj[value]}`)
                }
            });

            return telefones
        },
        save(){
            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    this.repositories.assistenciaSocial.store(this.prepareData())
                        .then(({ data }) => {

                            this.showSaveNotification()
                            this.$emit('save', data)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        prepareData() {

            const anotacoes = this.clone(this.model)

            anotacoes.usuarioId = this.form.usuarioSistemaId
            anotacoes.ocupacaoId = this.form.ocupacaoId
            anotacoes.dataAnotacao = moment(this.form.dataAtual, 'DD/MM/YYYY').format('YYYY-MM-DD');

            return this.camelObjectKeysToSnakeRecursive({
                anotacoes
            })
        },
        openFile() {

            this.setLoading()

            this.repositories.faaImpressao.faa.eletronica(this.id)
                .then(response => {

                    const content = new Blob([response.data], { type: response.headers['content-type'] })
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [repository, error, object, data, stringCase],
    filters: {
        ...format,
    },
    props: {
        id: { type: Number },
        readonly: { type: Boolean, default: false },
    },
}
</script>
<style scoped>

p {
    margin: 0px;
}
.col-svg {
    text-align: center !important;
}
.icon {
    width: auto !important;
    height: 96px !important;
    color: #007bff !important;
}
</style>